export const MIN_COLUMNS_NUMBER = 5;
